module.exports = __webpack_public_path__ + "static/media/14.2218cf52.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/14.png
// module id = 651
// module chunks = 0